import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  GetAllFinacUserPayloadType,
  GetAssignedClientsToUserPayloadType,
} from "../../commonTypes/authTypes";
import {
  AddGstRegisterBusinessPayloadType,
  IsGstRegisteredVerifyPayloadType,
  UpdateIdPasswordManagerPayloadType,
} from "../../commonTypes/stcoToolsType";
import AddEditIdPasswordManagerForm from "../../components/StcoTools/IdPasswordManager/AddEditIdPasswordManagerForm";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import useDebounce from "../../customHooks/useDebounce";
import {
  getAllFinacUsersAction,
  getAssignedClientsToUserAction,
  resetAssignedClientsToUserList,
  resetFinacUsersList,
  resetSession,
} from "../../redux/auth";
import {
  AssignedClientsToUserType,
  LoginResponseType,
} from "../../redux/auth/authTypes";
import { RootState } from "../../redux/rootReducers";
import {
  addGstRegisterBusinessAction,
  editIdPasswordManagerAction,
  isGstRegisteredVerifyAction,
  resetGstRegisterMessage,
  resetGstRegisterSuccess,
  resetIdPasswordManagerError,
  resetIdPasswordManagerStatusCode,
  resetIdPasswordManagerSuccess,
  resetIsGstRegisteredVerifyData,
  resetStcoToolsFetching,
} from "../../redux/stcoTools";
import { GetGstNumberPayload, GstNumberType } from "../../commonTypes/gstTypes";
import {
  getGstNumberList,
  resetGstModuleError,
  resetGstModuleSuccess,
  resetGstNumberList,
} from "../../redux/gstModule";
import { components } from "react-select";
import { Warning } from "../../assets/images";
import toast from "react-hot-toast";
import { IsGstRegisteredVerifyType } from "../../redux/stcoTools/stcoToolsType";
type AppProps = {
  history: any;
  loginData: LoginResponseType;
  fetching: boolean;
  userFetching: boolean;
  token: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetSession: () => void;
  dispatchResetIdPasswordManagerError: () => void;
  dispatchResetIdPasswordManagerSuccess: () => void;
  dispatchResetIdPasswordManagerStatusCode: () => void;
  dispatchResetFinacUsersList: () => void;
  finacUsersList: any;
  assignedClientsToUserList: [] | AssignedClientsToUserType[];
  dispatchEditIdPasswordManagerAction: (
    data: UpdateIdPasswordManagerPayloadType
  ) => void;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
  message: string | null;
  dispatchResetStcoToolsFetching: () => void;
};

const EditIdPasswordManager = ({
  history,
  token,
  loginData,
  success,
  statusCode,
  fetching,
  userFetching,
  error,
  dispatchGetAllFinacUsersAction,
  finacUsersList,
  dispatchResetSession,
  assignedClientsToUserList,
  dispatchEditIdPasswordManagerAction,
  dispatchResetIdPasswordManagerError,
  dispatchResetIdPasswordManagerSuccess,
  dispatchGetAssignedClientsToUserAction,
  dispatchResetIdPasswordManagerStatusCode,
  dispatchResetFinacUsersList,
  message,
  dispatchResetStcoToolsFetching,
}: AppProps) => {
  const editData = history?.location?.state?.data;
  const clientSelected = history?.location?.state?.clientSelected;
  const userSelected = history?.location?.state?.userSelected;
  const selectCategory = history?.location?.state?.selectCategory;
  const searchData = history?.location?.state?.searchData;
  const client_code = history?.location?.state?.data?.client_code;
  const fileAttachmentStatus =  history?.location?.state?.fileAttachementStatusValue
  const [offset, setoffset] = useState(0);
  const [text, setText] = useState("");
  const [limit, setLimit] = useState(20);

  const [clientCode, setClientCode] = useState<null | number>(null);
  const [gstNo, setGstNo] = useState<null | string>(null);
  const [finacApiCall, setFinacApiCall] = useState(false);
  const handleSubmitEditIdPasswordForm = (
    data: UpdateIdPasswordManagerPayloadType
  ) => {
    const finalData = {
      ...data,
    };
    dispatchEditIdPasswordManagerAction(finalData);
  };
  useEffect(() => {
    dispatchResetStcoToolsFetching();
    dispatchResetIdPasswordManagerError();
    dispatchResetIdPasswordManagerSuccess();
    dispatchResetIdPasswordManagerStatusCode();
    dispatchResetFinacUsersList();
    const finalData = {
      token,
      user_id: loginData?.user_id,
    };
    dispatchGetAssignedClientsToUserAction(finalData);
    //eslint-disable-next-line
  }, []);



 

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      if (offset <= finacUsersList?.total_count && finacApiCall) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
    //eslint-disable-next-line
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        setFinacApiCall(true);
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  const handleGoBack = () => {
    history.push({
      pathname: `/id-password-manager`,
      state: { clientSelected, userSelected, selectCategory, searchData ,fileAttachmentStatus},
    });
  };

  const clientCodeCallBack = (data: number) => {
    setClientCode(data);
  };
  const gstCallBack = (data: string) => {
    if (data) {
      setGstNo(data);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetIdPasswordManagerError();
            }}
          />
        );
      }
    }
    if (success === 1 && message === "Record updated succesfully!") {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Id Password Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetIdPasswordManagerSuccess();
            handleGoBack();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };


  return (
    <>
      <CommonHeader title="Edit Id/Password" />
      <ContentArea>
        <AddEditIdPasswordManagerForm
          history={history}
          fetching={fetching}
          userFetching={userFetching}
          token={token}
          loginData={loginData}
          finacUsersList={finacUsersList?.data}
          editData={editData}
          handleSubmitEditIdPasswordForm={handleSubmitEditIdPasswordForm}
          setoffset={setoffset}
          setText={setText}
          setLimit={setLimit}
          limit={limit}
          offset={offset}
          handleGoBack={handleGoBack}
          assignedClientsToUserList={assignedClientsToUserList}
          clientCodeCallBack={clientCodeCallBack}
        />
      </ContentArea>
      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.stcoTools.success,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,
  loginData: state.auth.loginData,
  fetching: state.stcoTools.fetching,
  userFetching: state.auth.fetching,
  assignedClientsToUserList: state.auth.assignedClientsToUserList,
  finacUsersList: state.auth.finacUsersList,
  message: state.stcoTools.message,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetIdPasswordManagerSuccess: () =>
    dispatch(resetIdPasswordManagerSuccess()),
  dispatchResetIdPasswordManagerError: () =>
    dispatch(resetIdPasswordManagerError()),
  dispatchResetIdPasswordManagerStatusCode: () =>
    dispatch(resetIdPasswordManagerStatusCode()),
  dispatchResetAssignedClientsToUserList: () =>
    dispatch(resetAssignedClientsToUserList()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchEditIdPasswordManagerAction: (
    data: UpdateIdPasswordManagerPayloadType
  ) => dispatch(editIdPasswordManagerAction(data)),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchResetStcoToolsFetching: () => dispatch(resetStcoToolsFetching()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditIdPasswordManager);
